import { useContext, useEffect, useState } from "react";
import NAVBAR from "components/navbar";
import api from "services/api";
import AdminTurismoModal from './modal';
import './style.css';
import config from 'config';
import FOOTER from "components/footer";
import PAGINACAO from "components/paginacao";
import { CidadeContext } from "services/cidade";
import RADIO from "components/radio";


function AdminTurismo(){
    const [lturismo, setLTurismo] = useState([]);
    const [tipo, setTipo] = useState(0);
    // removed unused loading state
    const { cod_cidade } = useContext(CidadeContext)


    // Modal
    const [operacao, setOperacao] = useState('')
    const [dados, setDados] = useState([]);
    const [isOpen, setIsOpen] = useState(false);

    function closeAdminTurismoModal(){
        setIsOpen(false);
    }

    useEffect(()=>{
        api.get(`${config.ADM_TURISMO}?tipo=${tipo}&cod_cidade=${cod_cidade}`)
            .then(response => {
                setLTurismo(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    },[isOpen, cod_cidade, tipo]);

    function novoTurismo(){
        setDados(           
            {
                "id_turismo": 0,
                "tipo": tipo,
                "descricao": "",
                "url_foto": "",
                "url_site": "",
                "ind_ativo": "S",
                "cod_cidade": cod_cidade,
            } 
        );
        setIsOpen(true);
    }

    function editarTurismo(linha){
        setOperacao('UPDATE')
        setDados(linha);
        setIsOpen(true);
    }
    function descicaotipo(tipo) {
        switch (tipo) {
            case 0:
                return 'Turismo';
            case 1:
                return 'Hoteis';
            case 2:
                return 'Alimentação';
            case 3:
                return 'Eventos';
                case 4:
                return 'Uteis';
            default:
                return 'Unknown';
        }
    }

    return <div>
        <NAVBAR />
        <AdminTurismoModal isOpen={isOpen}
                  onRequestClose={closeAdminTurismoModal}                 
                  operacao={operacao}
                  dados={dados}
        /> 
        <div className="mt-page">
            <h1>Turismo</h1>
            <div className="row">  
                <div className="col-md-12">
                    <label htmlFor="tipo" className="form-label">Tipo?</label>
                    <RADIO
                      chave={'tipo'}
                      alabel={['Turismo', 'Hoteis', 'Alimentação', 'Eventos', 'Uteis']}
                      avalores={[0,1,2,3,4]}
                      setValor={setTipo}
                      valor={tipo}
                    />
                  </div>
                </div>
            <PAGINACAO
                data={lturismo}
                itemsPerPage={20}
                renderItems={(currentItems) => (
                <table className="table table-striped table-bordered">
                <thead>
                    <tr>
                    <th scope="col"># <button type="button"
                    onClick={(e)=>novoTurismo()}
                    >Nova</button></th>
                    <th scope="col">ID</th> 
                    <th scope="col">Descrição</th>  
                    <th scope="col">Tipo</th>                              
                    <th scope="col">operação</th>
                    </tr>
                </thead>        
                <tbody>
                    {
                        currentItems.map((e, index) => (
                            <tr key={`turism${index}`}>
                                <th scope="row">{index + 1}</th>
                                <td>{e.id_turismo}</td>
                                <td>{e.descricao}</td>
                                <td>{descicaotipo(e.tipo)}</td>
                                <td>
                                    <button className='btn btn-warnning'
                                        type="button"
                                        onClick={() => editarTurismo(e)}>Editar</button>
                                </td>
                            </tr>
                        ))
                    }            
                </tbody>
                </table>
            )}
            />

        </div>
        <FOOTER />
    </div>
}

export default AdminTurismo;